module.exports = __webpack_public_path__ + "img/4.df1e0881.png";